import { HttpErrorResponse } from '@angular/common/http';

export function getErrorMessage(errorResponse: HttpErrorResponse, fromResponseBodyOnly?: boolean, errorMessage?: string): string {
    if (!fromResponseBodyOnly) {
        return errorResponse?.error?.message ||
        errorResponse?.error?.response ||
        errorResponse?.message ||
        errorMessage ||
        'Error';
    }
    return errorResponse?.error?.message || errorResponse?.error?.response;

}
